import { c as _c } from "react/compiler-runtime";
import type { Time } from '@morpho-org/morpho-ts';
import type { Address } from 'viem';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getHistoryRangeFromTimeFrame } from '@/helpers/timeseries';
import type { VaultHistoryMode } from './useCurrencyMode';
import { totalAssetsHistoryQueryOptions } from '../totalAssetsHistory.query';
import { toTotalDepositChartData } from '../toTotalDepositChartData';
interface UseTotalDepositTimeseriesDataParams {
  chainId: number;
  address: Address;
  timeFrame: Time.PeriodLike | null;
  dataMode: VaultHistoryMode;
  assetDecimals: number | null;
}

/**
 * The vault's total deposits over the timeframe, in USD or in the asset. Suspends until the range
 * loads; the server prefetches the default timeframe.
 */
export function useTotalDepositTimeseriesData(t0) {
  const $ = _c(8);
  const {
    chainId,
    address,
    timeFrame,
    dataMode,
    assetDecimals
  } = t0;
  let t1;
  if ($[0] !== address || $[1] !== chainId || $[2] !== timeFrame) {
    t1 = totalAssetsHistoryQueryOptions({
      chainId,
      address,
      range: getHistoryRangeFromTimeFrame(timeFrame)
    });
    $[0] = address;
    $[1] = chainId;
    $[2] = timeFrame;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data
  } = useSuspenseQuery(t1);
  let t2;
  if ($[4] !== assetDecimals || $[5] !== data.points || $[6] !== dataMode) {
    t2 = toTotalDepositChartData(data.points, dataMode, assetDecimals);
    $[4] = assetDecimals;
    $[5] = data.points;
    $[6] = dataMode;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}